import React, { useState, useEffect } from 'react';
import axios from 'axios';

// Podešavanje axios-a za CSRF
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

const SefUpload = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [status, setStatus] = useState("");
    const [uploading, setUploading] = useState(false);
    const [fakture, setFakture] = useState([]);
    const [selectedFaktura, setSelectedFaktura] = useState(null);

    const fetchFakture = async () => {
        try {
            setStatus("Učitavanje...");
            const res = await axios.get("https://ecopell.ledscreen.rs/core/get-sef-fakture/");
            setFakture(res.data);
            setStatus("Baza ažurirana.");
        } catch (err) {
            setStatus("Greška pri čitanju baze.");
        }
    };

    useEffect(() => {
        fetchFakture();
    }, []);

    const onFileUpload = async () => {
        if (!selectedFile) return;
        const formData = new FormData();
        formData.append("file", selectedFile);
        setUploading(true);
        try {
            await axios.post("https://ecopell.ledscreen.rs/core/upload-sef/", formData);
            fetchFakture();
            setStatus("Faktura obrađena.");
        } catch (err) {
            setStatus("Greška kod obrade.");
        } finally {
            setUploading(false);
        }
    };

    const obrisiFakturu = async (id, e) => {
        if (e) e.stopPropagation(); 
        if (!window.confirm("Da li ste sigurni da želite da obrišete ovu fakturu?")) return;
        try {
            await axios.post(`https://ecopell.ledscreen.rs/core/delete-sef-faktura/`, { id: id });
            if (selectedFaktura && selectedFaktura.id === id) setSelectedFaktura(null);
            fetchFakture();
            setStatus("Faktura obrisana.");
        } catch (err) {
            setStatus("Greška pri brisanju.");
        }
    };

    const posaljiNaSef = async (id) => {
        setStatus("Slanje na SEF...");
        try {
            const res = await axios.post(`https://ecopell.ledscreen.rs/core/send-to-sef/`, { id: id });
            alert(res.data.message || "Poslato u nacrte!");
            setStatus("Uspešno poslato.");
        } catch (err) {
            setStatus("Greška pri slanju na SEF.");
            alert("Greška: Proverite API ključ u backendu.");
        }
    };

    const thStyle = { padding: '12px', borderBottom: '2px solid #3366ff', textAlign: 'left', color: '#3366ff', backgroundColor: '#162447' };
    const tdStyle = { padding: '12px', borderBottom: '1px solid #1a2a4a', cursor: 'pointer' };
    const itemThStyle = { padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left', backgroundColor: '#f1f1f1', color: '#333', fontSize: '0.75em' };
    const itemTdStyle = { padding: '8px', borderBottom: '1px solid #eee', fontSize: '0.85em', color: '#444' };

    return (
        <div style={{ padding: '30px', color: 'white', backgroundColor: '#0a132b', minHeight: '100vh', fontFamily: 'sans-serif' }}>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '2px solid #ffcc00', paddingBottom: '15px', marginBottom: '25px' }}>
                <div>
                    <h2 style={{ margin: 0 }}>SEF ANALITIKA - DETALJAN PREGLED</h2>
                    <small style={{ color: '#888' }}>Prikaz svih podataka iz baze podataka</small>
                </div>
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                    <span style={{ color: '#00ff00' }}>{status}</span>
                    <button onClick={fetchFakture} style={{ backgroundColor: '#1a2a4a', color: 'white', border: '1px solid #3366ff', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer' }}>
                        OSVEŽI
                    </button>
                </div>
            </div>

            <div style={{ backgroundColor: '#162447', padding: '20px', borderRadius: '8px', marginBottom: '30px', border: '1px dashed #3366ff' }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                    <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} accept="application/pdf" style={{ flex: 1, padding: '10px', backgroundColor: '#0a132b', border: '1px solid #3366ff', color: 'white' }} />
                    <button onClick={onFileUpload} disabled={uploading} style={{ backgroundColor: '#28a745', color: 'white', padding: '10px 30px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>
                        {uploading ? "UČITAVANJE..." : "UČITAJ PDF"}
                    </button>
                </div>
            </div>

            {selectedFaktura && (
                <div style={{ backgroundColor: '#ffffff', color: '#333', padding: '30px', borderRadius: '10px', marginBottom: '40px', borderTop: '10px solid #ffcc00', boxShadow: '0 10px 40px rgba(0,0,0,0.6)' }}>
                    <div style={{ float: 'right', display: 'flex', gap: '10px' }}>
                        <button onClick={() => posaljiNaSef(selectedFaktura.id)} style={{ background: '#007bff', border: 'none', color: 'white', cursor: 'pointer', borderRadius: '5px', padding: '5px 15px', fontWeight: 'bold' }}>POŠALJI NA SEF</button>
                        <button onClick={() => obrisiFakturu(selectedFaktura.id)} style={{ background: '#dc3545', border: 'none', color: 'white', cursor: 'pointer', borderRadius: '5px', padding: '5px 15px', fontWeight: 'bold' }}>OBRIŠI</button>
                        <button onClick={() => setSelectedFaktura(null)} style={{ background: '#6c757d', border: 'none', color: 'white', cursor: 'pointer', borderRadius: '50%', width: '30px', height: '30px', fontWeight: 'bold' }}>X</button>
                    </div>
                    
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '50px', marginBottom: '30px', borderBottom: '2px solid #eee', paddingBottom: '20px' }}>
                        <div>
                            <h5 style={{ color: '#888', margin: '0 0 5px 0', fontSize: '0.8em' }}>PRODAVAC:</h5>
                            <strong style={{ fontSize: '1.1em' }}>{selectedFaktura.pib_p === "107752371" ? "ECOPELL GUCA BRANIMIR TANKOSIC PR" : "Nepoznato"}</strong><br/>
                            <span>PIB: {selectedFaktura.pib_p}</span><br/>
                            <small>Prote Gučanina 9, 32230 Guča</small>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <h5 style={{ color: '#888', margin: '0 0 5px 0', fontSize: '0.8em' }}>KUPAC:</h5>
                            <strong style={{ fontSize: '1.1em' }}>{selectedFaktura.kupac}</strong><br/>
                            <span>PIB: {selectedFaktura.pib_k}</span><br/>
                            <small>{selectedFaktura.adresa_k}</small>
                        </div>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px', marginBottom: '30px' }}>
                        <div style={{ background: '#f8f9fa', padding: '12px', borderRadius: '5px', border: '1px solid #eee' }}>
                            <label style={{ display: 'block', fontSize: '0.7em', color: '#999' }}>BROJ RAČUNA</label>
                            <strong style={{ fontSize: '1.1em' }}>{selectedFaktura.broj}</strong>
                        </div>
                        <div style={{ background: '#f8f9fa', padding: '12px', borderRadius: '5px', border: '1px solid #eee' }}>
                            <label style={{ display: 'block', fontSize: '0.7em', color: '#999' }}>DATUM RAČUNA</label>
                            <strong>{selectedFaktura.datum}</strong>
                        </div>
                        <div style={{ background: '#f8f9fa', padding: '12px', borderRadius: '5px', border: '1px solid #eee' }}>
                            <label style={{ display: 'block', fontSize: '0.7em', color: '#999' }}>DATUM VALUTE</label>
                            <strong>{selectedFaktura.valuta}</strong>
                        </div>
                        <div style={{ background: '#f8f9fa', padding: '12px', borderRadius: '5px', border: '1px solid #eee' }}>
                            <label style={{ display: 'block', fontSize: '0.7em', color: '#999' }}>MESTO</label>
                            <strong>GUCA</strong>
                        </div>
                    </div>

                    <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '25px' }}>
                        <thead>
                            <tr>
                                <th style={itemThStyle}>Opis usluge / dobra</th>
                                <th style={{ ...itemThStyle, textAlign: 'center', width: '60px' }}>Kol.</th>
                                <th style={{ ...itemThStyle, textAlign: 'center', width: '50px' }}>JM</th>
                                <th style={{ ...itemThStyle, textAlign: 'right', width: '120px' }}>Cena bez PDV</th>
                                <th style={{ ...itemThStyle, textAlign: 'right', width: '120px' }}>Ukupno sa PDV</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedFaktura.stavke && selectedFaktura.stavke.map((s, i) => (
                                <tr key={i}>
                                    <td style={itemTdStyle}>{s.opis}</td>
                                    <td style={{ ...itemTdStyle, textAlign: 'center' }}>{s.kolicina}</td>
                                    <td style={{ ...itemTdStyle, textAlign: 'center' }}>{s.jm}</td>
                                    <td style={{ ...itemTdStyle, textAlign: 'right' }}>{parseFloat(s.cena_bez_pdv).toLocaleString('de-DE', {minimumFractionDigits: 2})}</td>
                                    <td style={{ ...itemTdStyle, textAlign: 'right', fontWeight: 'bold' }}>{parseFloat(s.ukupno).toLocaleString('de-DE', {minimumFractionDigits: 2})}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <div style={{ width: '350px', backgroundColor: '#f1f4f9', padding: '20px', borderRadius: '8px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                <span style={{ color: '#666' }}>Ukupna osnovica:</span>
                                <strong>{selectedFaktura.osnovica.toLocaleString('de-DE', {minimumFractionDigits: 2})}</strong>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
                                <span style={{ color: '#666' }}>Ukupan PDV (20%):</span>
                                <strong>{selectedFaktura.pdv.toLocaleString('de-DE', {minimumFractionDigits: 2})}</strong>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.3em', color: '#28a745' }}>
                                <strong>ZA UPLATU:</strong>
                                <strong>{selectedFaktura.iznos.toLocaleString('de-DE', {minimumFractionDigits: 2})} RSD</strong>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div style={{ backgroundColor: '#162447', padding: '15px', borderRadius: '8px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th style={thStyle}>Broj</th>
                            <th style={thStyle}>Kupac</th>
                            <th style={thStyle}>PIB Kupca</th>
                            <th style={thStyle}>Iznos</th>
                            <th style={thStyle}>Datum</th>
                            <th style={{ ...thStyle, width: '50px' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {fakture.map(f => (
                            <tr key={f.id} onClick={() => setSelectedFaktura(f)} className="row-hover">
                                <td style={tdStyle}>{f.broj}</td>
                                <td style={tdStyle}>{f.kupac}</td>
                                <td style={tdStyle}>{f.pib_k}</td>
                                <td style={{ ...tdStyle, color: '#00ff00', fontWeight: 'bold' }}>{f.iznos.toLocaleString('de-DE', {minimumFractionDigits: 2})}</td>
                                <td style={tdStyle}>{f.datum}</td>
                                <td style={tdStyle}>
                                    <button onClick={(e) => obrisiFakturu(f.id, e)} style={{ background: 'none', border: 'none', color: '#ff4d4d', cursor: 'pointer' }} title="Obriši">
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <style>{`
                .row-hover:hover { background-color: #1a2a4a !important; cursor: pointer; }
                label { font-weight: bold; }
            `}</style>
        </div>
    );
};

export default SefUpload;